import React, { Component } from "react";
import { Accessor, ColorX, GState, LocaleX, ZMath } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, XButton, XImage, XText } from "IZOX/_X";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import Funcs from "__SYSDefault/Funcs";

/**
 * @augments {Component<Props, State>}
 */
class Menu extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Menu.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderPageBtn(caption, page, range){
    let {history, toPage} = this.props;
    let {location} = history ?? {};
    let {pathname} = location ?? {};
    let isCurrentPage = pathname === page;

    let isInRange = false;
    if(pathname.includes("Home")){
      isInRange = ZMath.IsBetween(GState.indexScroll, range?.min, range?.max);
    }

    return (
      <XButton color={ColorX.CSS(isCurrentPage || (GState.menuClick === "" && isInRange) || GState.menuClick === page ? "Axit" : "Stone")}
        onPress={() => {
          toPage?.(page);
          Funcs.SetMenuClick(page ?? "");
        }}>
        <HStack>
          <XText fontSize={14}>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderContactUs(){
    let {toPage} = this.props;
    return (
      <XButton onPress={() => toPage?.("/ContactUs")}
        pV={8}
        pH={12}
        bgColor={ColorX.CSS("Axit")}
        color={ColorX.CSS("pureWhite")}
        round={30}>
        <HStack spacing={8}>
          <XImage source="/Images/Icons/phone.png" noResize/>
          <XText fontSize={14}>
            {LocaleX.Parse({
              EN: "Contact Us",
              TC: "聯絡我們"
            })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  render(){
    return (
      <HStack width={"auto"} spacing={24}>
        {this.renderPageBtn({
          EN: "Services",
          TC: "服務"
        }, "/Home#services", {min: -2299, max: -1516})}
        {this.renderPageBtn({
          EN: "About Us",
          TC: "關於我們"
        }, "/Home#aboutus", {min: -108, max: 811})}
        {this.renderPageBtn({
          EN: "General Insurance",
          TC: "一般保險"
        }, "/GeneralInsurance")}
        {this.renderPageBtn({
          EN: "Terms and Conditions",
          TC: "條款及細則"
        }, "/TandC")}
        {this.renderPageBtn({
          EN: "Payment",
          TC: "支付"
        }, "/Payment")}
        {this.renderContactUs()}
      </HStack>
    );
  }

}

export default withRouter(observer(Menu));
